import React, { useRef, useEffect } from "react";
import themePropTypes from "../theme-prop-types";

const Description = ({ description, name, forceFocus = false }) => {
  const descriptionRef = useRef();

  useEffect(() => {
    if (forceFocus) {
      descriptionRef.current.focus();
    }
  }, [forceFocus]);

  return (
    <p
      className='description-web-sdk'
      ref={descriptionRef}
      data-testid={`description-${name}`}
    >
      {/* Temporary and actually safe b/c description is not sourced from user supplied content */}
      <div dangerouslySetInnerHTML={{ __html: description }} />
    </p>
  );
};

Description.propTypes = themePropTypes.description;

export default Description;
